export const is_valorized = (value: unknown): boolean => {
  return value !== null && value !== undefined
}

export const is_void_obj = (value: unknown): boolean => {
  return JSON.stringify(value) === '{}'
}
